<script setup lang="ts">
import FooterSection from '~/components/landing/FooterSection.vue';
import Navbar from '~/components/landing/Navbar.vue';

// Watch for route changes, if it has #how-it-works, scroll to the section
const route = useRoute();
watch(
  () => route.hash,
  (newHash) => {
    if (newHash === '#how-it-works') {
      const element = document.getElementById('how-it-works');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
  { immediate: true },
);
</script>

<template>
  <div class="w-full bg-linear-to-b from-[#D8F1FF] from-0% to-white to-45%">
    <Navbar />
    <NuxtPage :page-key="(route) => route.fullPath" />
    <FooterSection class="mt-14" />
  </div>
</template>
